import { api } from "../utils/AuthManager";

const PostFamilyMemberPackage = async (id, formData) => {
  return api
    .post(`/api/family_member_package/${id}/`, formData)

    .then((res) => {
      return res;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export default PostFamilyMemberPackage;
